import { render, staticRenderFns } from "./SandboxTemplateDetail.vue?vue&type=template&id=51b41a1a&scoped=true&"
import script from "./SandboxTemplateDetail.vue?vue&type=script&lang=js&"
export * from "./SandboxTemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./SandboxTemplateDetail.vue?vue&type=style&index=0&id=51b41a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b41a1a",
  null
  
)

export default component.exports